export type TilbyDBVersion = {
    version: number
    stores: Record<string, string | null>
}

export const dbVersions: TilbyDBVersion[] = [{
    version: 1,
    stores: {
        entity_schemas: "id",
        //Api Entities
        rooms: "id,dirty,deleted",
        orders: "id,dirty,deleted",
        shop_settings: "id,dirty,deleted",
        user_settings: "id_compound,user_id,dirty,deleted",
        user_preferences: "id_compound,user_id,dirty,deleted",
        shop_preferences: "id,dirty,deleted",
        static_resources: "id,dirty,deleted",
        items: "id,dirty,deleted",
        categories: "id,dirty,deleted",
        departments: "id,dirty,deleted",
        vat: "id,dirty,deleted",
        customers: "id,dirty,deleted",
        components: "id,dirty,deleted",
        printers: "id,dirty,deleted",
        sales: "id,dirty,deleted",
        payment_methods: "id,dirty,deleted",
        allergens: "id,dirty,deleted",
        //media is not an entity stored
        daily_closings: "id,dirty,deleted",
        tickets: "id,dirty,deleted",

        //and others here
        shop_session: "id",
        user_sessions: "id,active"
    }
}, {
    version: 2,
    stores: {
        suppliers: "id,dirty,deleted",
        stock: "id,dirty,deleted",
        raw_materials: "id,dirty,deleted"
    }
}, {
    version: 3,
    stores: {
        dgfe: "id,dirty,deleted"
    }
}, {
    version: 4,
    stores: {
        fidelities_points: "id,dirty,deleted",
        campaigns: "id,dirty,deleted"
    }
}, {
    version: 5,
    stores: {
        cash_movements: "id,dirty,deleted"
    }
}, {
    version: 6,
    stores: {
        static_resources: null
    }
}, {
    version: 7,
    stores: {
        application_reports: "id, dirty, deleted"
    }
}, {
    version: 8,
    stores: {
        nonfiscal_documents: "id, dirty, deleted"
    }
}, {
    version: 9,
    stores: {
        channels: "id,dirty,deleted"
    }
}, {
    version: 10,
    stores: {
        bookings: "id,dirty,deleted",
        booking_shifts: "id,dirty,deleted",
    }
}, {
    version: 11,
    stores: {
        prizes: "id,dirty,deleted"
    }
}, {
    version: 12,
    stores: {
        promotions: "id,dirty,deleted"
    }
}, {
    version: 13,
    stores: {
        activity_codes: "id,dirty,deleted"
    }
}, {
    version: 14,
    stores: {
        api_backup: "id,dirty"
    }
}, {
    version: 15,
    stores: {
        slave_devices: "id,uuid,session_token,dirty,deleted"
    }
}, {
    version: 16,
    stores: {
        api_backup: null,
        sale_transactions: "id,uuid,dirty,deleted"
    }
}, {
    version: 17,
    stores: {
        pending_prints: 'id'
    }
}, {
    version: 18,
    stores: {
        device_preferences: "id,dirty,deleted"
    }
}, {
    version: 19,
    stores: {
        orders: null
    }
}];